import CoachingPlanActions from 'actions/coaching/CoachingPlanActions';
import fetchMissingUsers from 'utils/fetchMissingUsers';
import DirectReportsActions from 'actions/coaching/DirectReportsActions';

export function refreshCoachingPlansAndVelocities(managerOrCoachId) {
  return CoachingPlanActions.fetchForDirectReports(managerOrCoachId).then(plans => {
    // Fetch users we may need to show as coaches in the active reps list.
    const coachIds = plans.flatMap(plan => plan.reviews.map(review => review.coachUserId));
    fetchMissingUsers(coachIds);
    DirectReportsActions.planVelocities(plans.map(p => p.id).toSet());
  });
}
